import statsigReporter from '@cdo/apps/metrics/StatsigReporter';

// Runs Statsig Web Analytics auto-capturing.
statsigReporter.runAutoCapture();
